import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ThemeService } from './core/services/theme.service';

@Component({
    selector: 'dmp-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  constructor(private readonly themeService: ThemeService) {}
}
